export const OIB_REGEX = /^\d{11}$/;
